'use strict';

var processInclude = require('./components/processInclude');

jQuery(function () {
    processInclude(require('./notifyMe/notifyMe'));
    processInclude(require('./product/detail'));

    // hacky solution to making BV in-drawer review links open accordion drawers
    $(document).on('mousedown', 'a[data-content-type="review"], .bv-rating, a.bv-rating-stars-container, a.bv-rating-label', function (e) {
        var accordionHeader = $('.product-accordion-reviews__header');
        if (accordionHeader.hasClass('collapsed')) {
            e.preventDefault();
            accordionHeader.trigger('click');
            var reviewAnchorOffset = $('#product-accordion-reviews').offset();
            $('body').animate({
                scrollTop: reviewAnchorOffset.top
            });
        }
    });
});
